<div class="m-4" *ngIf="eventsNotFound">
  <h2>Occurrences not found</h2>
</div>

<div class="m-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="m-4" *ngIf="!eventsNotFound && (serverError === null)">

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert"
         *ngIf="successMessage !== ''">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <div class="form-group">
    <select class="custom-select w-auto"
            name="locationSelect"
            id="locationSelect"
            [(ngModel)]="locationId">
      <option *ngIf="locations === null"
              [ngValue]="null"
              disabled class="disabled">
        Loading...
      </option>
      <ng-container *ngIf="locations !== null">
        <option [ngValue]="null">All Locations</option>
        <option *ngFor="let location of locations"
                [ngValue]="location.id">
          {{ location.name }}
        </option>
      </ng-container>
    </select>

    <select class="custom-select w-auto ml-2"
            name="hideEnded"
            id="hideEnded"
            [(ngModel)]="hideEnded">
      <option [ngValue]="true">Hide Ended Occurrences</option>
      <option [ngValue]="false">Show Ended Occurrences</option>
    </select>

    <div class="float-right">
      <a class="btn btn-success"
         [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedules/add'">
        Add Occurrence
      </a>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th>Dates</th>
        <th>Location</th>
        <th>Capacity</th>
        <th>Pricing Matrix</th>
        <th></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingEventsList">
      <tr *ngFor="let event of getFilteredEvents()">
        <td>
          <ng-container *ngIf="event.occurrence_name !== ''">
            <i>{{ event.occurrence_name }}</i>
            <br>
          </ng-container>
          <ng-container *ngIf="(event.occurrence_name === '') && (event.customer_facing_name !== '')">
            <i>{{ event.customer_facing_name }}</i>
            <br>
          </ng-container>
          <ng-container *ngFor="let eventPart of event.event_parts.slice(0, 4)">
            {{ dayOfWeekStringFromISO8601(eventPart.start_date) }},
            {{ dateStringFromISO8601(eventPart.start_date) }},
            {{ timeStringFromISO8601TimeOnly(eventPart.start_time) }} -
            {{ timeStringFromISO8601TimeOnly(eventPart.start_time, eventPart.duration_minutes) }}
            <br>
          </ng-container>
          <i *ngIf="event.event_parts.length > 4">
            + {{ event.event_parts.length - 4}}
            more date{{ event.event_parts.length > 5 ? 's' : '' }}
          </i>
        </td>
        <td>{{ event.location_name }}</td>
        <td>{{ event.capacity }}</td>
        <td>
          <span *ngIf="event.pricing_matrix_id">{{ getPricingMatrixNameById(event.pricing_matrix_id) }}</span>
          <span *ngIf="!event.pricing_matrix_id" class="text-muted">None</span>
        </td>
        <td class="table-button-cell">
          <div class="float-right">
            <a class="btn btn-primary btn-sm mr-2"
                  [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedules/' + event.id.toString()">
              Edit
            </a>
            <button class="btn btn-primary btn-sm mr-2"
                    (click)="submitDuplicateEvent(event)">
              Duplicate
            </button>
            <button class="btn btn-danger btn-sm"
                    (click)="submitRemoveEvent(event)">
              Remove
            </button>
          </div>
        </td>
      </tr>
      <tr *ngIf="getFilteredEvents().length === 0">
        <td colspan="99" class="text-muted">No Occurrences</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingEventsList">
      <tr>
        <td colspan="99" class="text-muted">Loading...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="alert alert-info" role="alert" *ngIf="loadingEventsList">
    Loading occurrences...
  </div>

  <div class="float-right">
    <a class="btn btn-primary"
       [routerLink]="'/events/setup/edit/' + eventType?.id + '/questions'">
      Continue
    </a>
  </div>
  <button [routerLink]="['/events/setup/event-types']"
          [queryParams]="{status: eventType?.status}"
          class="btn btn-secondary">
    Back
  </button>

</div>
